import { Checkbox, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles({
  cellRoot: {
    overflow: 'visible',
    textAlign: 'center',
    paddingLeft: '8px',
    paddingRight: '0px',
  },
  SimpleTableCheckboxRoot: {
    padding: 0,
  },
});

function TableSelectionCell(props) {
  const classes = useStyles();

  const handleClick = (prop) => {
    return (e) => {
      e.stopPropagation();
      e.preventDefault();
      prop.onToggle();
      if (!prop.selected) {
        if (prop.selectionType === 'TODOS_FILTRO' && prop.selection.length === prop.totalCount - 1) {
          prop.onSelectionChange([]);
          prop.onSelectionTypeChange('NENHUM');
        } else {
          prop.onSelectionChange([...prop.selection, prop.row]);
        }
      } else if (prop.selection.some((s) => s.id === prop.row.id && prop.selected)) {
        prop.onSelectionChange(prop.selection.filter((s) => s.id !== prop.row.id));
      }
    };
  };

  return (
    <td
      className={clsx('MuiTableCell-root MuiTableCell-body MuiTableCell-paddingCheckbox', classes.cellRoot)}
      colSpan={props.colSpan}
    >
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Checkbox
          classes={{ root: classes.SimpleTableCheckboxRoot }}
          checked={props.selectionType === 'TODOS_FILTRO' ? !props.selected : props.selected}
          onClick={handleClick(props)}
          color="primary"
        />
        <div style={{ width: '24px' }} />
      </span>
    </td>
  );
}

export default TableSelectionCell;
